import React from 'react';
import { buttonClasses } from './buttonStyles';

const SecondaryButton = ({ children, size = 'md', className = '', ...props }) => {
  return (
    <button {...props} className={buttonClasses("border border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50", size, className)}>
      {children}
    </button>
  );
};

export default SecondaryButton;
